<!-- Page 1 -->
<div class="pdf-page app-cp-10-10-10-12" id="cp10101012">
  <div class="t-right p-5">
    <p class="font-small mb-0"><b>COMMERCIAL PROPERTY</b></p>
    <p class="font-small"><b>CP 10 10 10 12</b></p>
  </div>

  <div>
    <p class="font-large mb-0" style="text-align: center">
      <b>CAUSES OF LOSS - BASIC FORM</b>
    </p>
    <br />
    <div class="font-small">
      <p>
        Words and phrases that appear in quotation marks have special meaning.
        Refer to Section <b>E.</b> Definitions.
      </p>
    </div>
    <table class="font-small" style="width: 100%">
      <tbody>
        <tr>
          <!-- Left -->
          <td style="width: 50%; vertical-align: top">
            <ol type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                <b>Covered Causes Of Loss</b><br />
                When Basic is shown in the Declarations, Covered Causes of Loss
                means the following:
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Fire.</span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Lightning.</span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Explosion, including the explosion of gases or fuel within
                    the furnace of any fired vessel or within the flues or
                    passages through which the gases of combustion pass. This
                    cause of loss does not include loss or damage by:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        Rupture, bursting or operation of pressure-relief
                        devices; or
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        Rupture or bursting due to expansion or swelling of the
                        contents of any building or structure, caused by or
                        resulting from water.
                      </span>
              </li>
                    </ol>
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Windstorm or Hail, but not including:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Frost or cold weather;</span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        Ice (other than hail), snow or sleet, whether driven by
                        wind or not;
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        Loss or damage to the interior of any building or
                        structure, or the property inside the building or
                        structure, caused by rain, snow, sand or dust, whether
                        driven by wind or not, unless the building or structure
                        first sustains wind or hail damage to its roof or walls
                        through which the rain, snow, sand or dust enters; or
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        Loss or damage by hail to lawns, trees, shrubs or plants
                        which are part of a vegetated roof.
                      </span>
              </li>
                    </ol>
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Smoke causing sudden and accidental loss or damage. This
                    cause of loss does not include smoke from agricultural
                    smudging or industrial operations.
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Aircraft or Vehicles, meaning only physical contact of an
                    aircraft, a spacecraft, a self-propelled missile, a vehicle
                    or an object thrown up by a vehicle with the described
                    property or with the building or structure containing the
                    described property. This cause of loss includes loss or
                    damage by objects falling from aircraft.<br />
                    We will not pay for loss or damage caused by or resulting
                    from vehicles you own or which are operated in the course of
                    your business.
                  </span>
              </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <!-- Right -->
          <td style="width: 50%; vertical-align: top">
            <ol start="7">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                Riot or Civil Commotion, including:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Acts of striking employees while occupying the described
                    premises; and
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Looting occurring at the time and place of a riot or civil
                    commotion.
                  </span>
              </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                Vandalism, meaning willful and malicious damage to, or
                destruction of, the described property. <br />
                We will not pay for loss or damage caused by or resulting from
                theft, except for building damage caused by the breaking in or
                exiting of burglars.
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                Sprinkler Leakage, meaning leakage or discharge of any substance
                from an Automatic Sprinkler System, including collapse of a tank
                that is part of the system. <br />
                If the building or structure containing the Automatic Sprinkler
                System is Covered Property, we will also pay the cost to:
                <ol type="a">
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Repair or replace damaged parts of the Automatic Sprinkler
                    System if the damage:
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(1) </b>Results in sprinkler leakage; or</span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(2) </b>Is directly caused by freezing.</span>
              </li>
                    </ul>
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    Tear out and replace any part of the building or structure
                    to repair damage to the Automatic Sprinkler System that has
                    resulted in sprinkler leakage. <br />
                    Automatic Sprinkler System means:
                    <ul style="list-style-type: none">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        <b>(1) </b>Any automatic fire-protective or
                        extinguishing system, including connected:
                        <ul style="list-style-type: none">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(a) </b>Sprinklers and discharge nozzles;</span>
              </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(b) </b>Ducts, pipes, valves and fittings;</span>
              </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                            <b>(c) </b>Tanks, their component parts and
                            supports; and
                          </span>
              </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                            <b>(d) </b>Pumps and private fire protection mains.
                          </span>
              </li>
                        </ul>
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        <b>(2) </b>When supplied from an automatic
                        fire-protective system:
                        <ul style="list-style-type: none">
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                            <b>(a) </b>Non-automatic fire-protective systems;
                            and
                          </span>
              </li>
                          <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                            <b>(b) </b>

                            Hydrants, standpipes and outlets.
                          </span>
              </li>
                        </ul>
                      </span>
              </li>
                    </ul>
                  </span>
              </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Page 2 -->
<div class="pdf-page app-cp-10-10-10-12">
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol start="10">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Sinkhole Collapse, meaning loss or damage caused by the sudden
                  sinking or collapse of land into underground empty spaces
                  created by the action of water on limestone or dolomite. This
                  cause of loss does not include:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">The cost of filling sinkholes; or</span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      Sinking or collapse of land into man-made underground
                      cavities.
                    </span>
              </li>
                  </ol>
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Volcanic Action, meaning direct loss or damage resulting from
                  the eruption of a volcano when the loss or damage is caused
                  by:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Airborne volcanic blast or airborne shock waves;</span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Ash, dust or particulate matter; or</span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Lava flow.</span>
              </li>
                  </ol>
                  With respect to coverage for Volcanic Action as set forth in
                  <b>11.a., 11.b.</b> and <b>11.c.,</b> all volcanic eruptions
                  that occur within any 168-hour period will constitute a single
                  occurrence. <br />
                  This cause of loss does not include the cost to remove ash,
                  dust or particulate matter that does not cause direct physical
                  loss or damage to the described property.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ul>
          <ol type="A" start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Exclusions</b>
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  We will not pay for loss or damage caused directly or
                  indirectly by any of the following. Such loss or damage is
                  excluded regardless of any other cause or event that
                  contributes concurrently or in any sequence to the loss.
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>Ordinance Or Law</b><br />
                      The enforcement of or compliance with any ordinance or
                      law:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(1) </b>Regulating the construction, use or repair
                          of any property; or
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(2) </b>Requiring the tearing down of any property,
                          including the cost of removing its debris.
                          <p class="mt-2">
                            This exclusion, Ordinance Or Law, applies whether
                            the loss results from:
                          </p>
                          <ul style="list-style-type: none">
                            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                              <b>(a) </b>An ordinance or law that is enforced
                              even if the property has not been damaged; or
                            </span>
              </li>
                            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                              <b>(b) </b>The increased costs incurred to comply
                              with an ordinance or law in the course of
                              construction, repair, renovation, remodeling or
                              demolition of property, or removal of its debris,
                              following a physical loss to that property.
                            </span>
              </li>
                          </ul>
                        </span>
              </li>
                      </ul>
                    </span>
              </li>
                  </ol>
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Earth Movement</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1)</b>Earthquake, including tremors and aftershocks and
                  any earth sinking, rising or shifting related to such event;
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2)</b>Landslide, including any earth sinking, rising or
                  shifting related to such event;
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(3)</b>Mine subsidence, meaning subsidence of a man-made
                  mine, whether or not mining activity has ceased;
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(4)</b>Earth sinking (other than sinkhole collapse), rising
                  or shifting including soil conditions which cause settling,
                  cracking or other disarrangement of foundations or other parts
                  of realty. Soil conditions include contraction, expansion,
                  freezing, thawing, erosion, improperly compacted soil and the
                  action of water under the ground surface.
                </span>
              </li>
                <p class="mt-2">
                  But if Earth Movement, as described in
                  <b>b.(1)</b>
                  through
                  <b>(4)</b>
                  above, results in fire or explosion, we will pay for the loss
                  or damage caused by that fire or explosion.
                </p>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(5)</b>Volcanic eruption, explosion or effusion. But if
                  volcanic eruption, explosion or effusion results in fire or
                  Volcanic Action, we will pay for the loss or damage caused by
                  that fire or Volcanic Action.
                </span>
              </li>
                <p class="mt-2">
                  This exclusion applies regardless of whether any of the above,
                  in Paragraphs
                  <b>(1)</b>
                  through
                  <b>(5)</b>, is caused by an act of nature or is otherwise
                  caused.
                </p>
              </ul>
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Governmental Action</b><br />
              Seizure or destruction of property by order of governmental
              authority. <br />
              But we will pay for loss or damage caused by or resulting from
              acts of destruction ordered by governmental authority and taken at
              the time of a fire to prevent its spread, if the fire would be
              covered under this Coverage Part.
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Nuclear Hazard</b><br />
              Nuclear reaction or radiation, or radioactive contamination,
              however caused. <br />
              But if nuclear reaction or radiation, or radioactive
              contamination, results in fire, we will pay for the loss or damage
              caused by that fire.
            </span>
              </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 3 -->
<div class="pdf-page app-cp-10-10-10-12">
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="5">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Utility Services </b><br />
              The failure of power, communication, water or other utility
              service supplied to the described premises, however caused, if the
              failure:
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>Originates away from the described premises; or
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>Originates at the described premises, but only if
                  such failure involves equipment used to supply the utility
                  service to the described premises from a source away from the
                  described premises.
                </span>
              </li>
              </ul>
              Failure of any utility service includes lack of sufficient
              capacity and reduction in supply.<br />
              Loss or damage caused by a surge of power is also excluded, if the
              surge would not have occurred but for an event causing a failure
              of power.<br />
              But if the failure or surge of power, or the failure of
              communication, water or other utility service, results in a
              Covered Cause of Loss, we will pay for the loss or damage caused
              by that Covered Cause of Loss.<br />
              Communication services include but are not limited to service
              relating to Internet access or access to any electronic, cellular
              or satellite network.
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>War And Military Action</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(1) </b>War, including undeclared or civil war;</span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>Warlike action by a military force, including
                  action in hindering or defending against an actual or expected
                  attack, by any government, sovereign or other authority using
                  military personnel or other agents; or
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(3) </b>Insurrection, rebellion, revolution, usurped power,
                  or action taken by governmental authority in hindering or
                  defending against any of these.
                </span>
              </li>
              </ul>
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Water</b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>Flood, surface water, waves (including tidal wave
                  and tsunami), tides, tidal water, overflow of any body of
                  water, or spray from any of these, all whether or not driven
                  by wind (including storm surge);
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(2) </b>Mudslide or mudflow;</span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(3) </b>Water that backs up or overflows or is otherwise
                  discharged from a sewer, drain, sump, sump pump or related
                  equipment;
                </span>
              </li>
              </ul>
            </span>
              </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(4) </b>Water under the ground surface pressing on, or
                      flowing or seeping through:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(a) </b> Foundations, walls, floors or paved
                          surfaces;
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(b) </b>Basements, whether paved or not; or</span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(c) </b>Doors, windows or other openings; or</span>
              </li>
                      </ul>
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(5) </b>Waterborne material carried or otherwise moved
                      by any of the water referred to in Paragraph
                      <b>(1) , (3)</b> or <b>(4)</b>, or material carried or
                      otherwise moved by mudslide or mudflow.
                    </span>
              </li>
                    <p class="mt-2">
                      This exclusion applies regardless of whether any of the
                      above, in Paragraphs
                      <b>(1)</b> through <b>(5)</b>, is caused by an act of
                      nature or is otherwise caused. An example of a situation
                      to which this exclusion applies is the situation where a
                      dam, levee, seawall or other boundary or containment
                      system fails in whole or in part, for any reason, to
                      contain the water.
                    </p>
                    <p class="mt-2">
                      But if any of the above, in Paragraphs
                      <b>(1)</b> through <b>(5)</b>, results in fire, explosion
                      or sprinkler leakage, we will pay for the loss or damage
                      caused by that fire, explosion or sprinkler leakage (if
                      sprinkler leakage is a Covered Cause of Loss).
                    </p>
                  </ul>
                </span>
              </li>
              </ul>
            </span>
              </li>
          </ul>
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol type="a" start="8">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>"Fungus", Wet Rot, Dry Rot And Bacteria</b> Presence,
                  growth, proliferation, spread or any activity of "fungus", wet
                  or dry rot or bacteria.<br />
                  But if "fungus", wet or dry rot or bacteria result in a
                  Covered Cause of Loss, we will pay for the loss or damage
                  caused by that Covered Cause of Loss.<br />
                  This exclusion does not apply:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(1) </b>When "fungus", wet or dry rot or bacteria
                      result from fire or lightning; or
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(2) </b> To the extent that coverage is provided in the
                      Additional Coverage, Limited Coverage For "Fungus", Wet
                      Rot, Dry Rot And Bacteria, with respect to loss or damage
                      by a cause of loss other than fire or lightning.
                    </span>
              </li>
                  </ul>
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ul>
          <p>
            Exclusions <b>B.1.a.</b> through <b>B.1.h.</b> apply whether or not
            the loss event results in widespread damage or affects a substantial
            area.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 4 -->
<div class="pdf-page app-cp-10-10-10-12">
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              We will not pay for loss or damage caused by or resulting from:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Artificially generated electrical, magnetic or electromagnetic
                  energy that damages, disturbs, disrupts or otherwise
                  interferes with any:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(1)</b>Electrical or electronic wire, device,
                      appliance, system or network; or
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(2)</b>Device, appliance, system or network utilizing
                      cellular or satellite technology.
                    </span>
              </li>
                  </ul>
                  For the purpose of this exclusion, electrical, magnetic or
                  electromagnetic energy includes but is not limited to:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(a)</b>Electrical current, including arcing;</span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(b)</b>Electrical charge produced or conducted by a
                          magnetic or electromagnetic field;
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(c)</b>Pulse of electromagnetic energy; or</span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(d)</b>Electromagnetic waves or microwaves.</span>
              </li>
                      </ul>
                    </span>
              </li>
                  </ul>
                  But if fire results, we will pay for the loss or damage caused
                  by that fire.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Rupture or bursting of water pipes (other than Automatic
                  Sprinkler Systems) unless caused by a Covered Cause of Loss.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Leakage or discharge of water or steam from any part of a
                  system or appliance containing water or steam (other than an
                  Automatic Sprinkler System), unless the leakage or discharge
                  occurs because the system or appliance was damaged by a
                  Covered Cause of Loss. But we will not pay for loss or damage
                  caused by or resulting from continuous or repeated seepage or
                  leakage of water, or the presence or condensation of humidity,
                  moisture or vapor, that occurs over a period of 14 days or
                  more.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Explosion of steam boilers, steam pipes, steam engines or
                  steam turbines owned or leased by you, or operated under your
                  control. <br />
                  But if explosion of steam boilers, steam pipes, steam engines
                  or steam turbines results in fire or combustion explosion, we
                  will pay for the loss or damage caused by that fire or
                  combustion explosion.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Mechanical breakdown, including rupture or bursting caused by
                  centrifugal force. <br />
                  But if mechanical breakdown results in a Covered Cause of
                  Loss, we will pay for the loss or damage caused by that
                  Covered Cause of Loss.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol type="a" start="6">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  Neglect of an insured to use all reasonable means to save and
                  preserve property from further damage at and after the time of
                  loss.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ul>
          <ol start="3">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Special Exclusions</b><br />
              The following provisions apply only to the specified Coverage
              Forms:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>
                    Business Income (And Extra Expense) Coverage Form, Business
                    Income (Without Extra Expense) Coverage Form, Or Extra
                    Expense Coverage Form </b
                  ><br />
                  We will not pay for:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(1) </b>Any loss caused by or resulting from:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(a) </b>Damage or destruction of "finished stock";
                          or
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(b) </b>The time required to reproduce "finished
                          stock".
                        </span>
              </li>
                      </ul>
                      This exclusion does not apply to Extra Expense.
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(2) </b>Any loss caused by or resulting from direct
                      physical loss or damage to radio or television antennas
                      (including satellite dishes) and their lead-in wiring,
                      masts or towers.
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(3) </b>Any increase of loss caused by or resulting
                      from:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(a) </b>Delay in rebuilding, repairing or replacing
                          the property or resuming "operations", due to
                          interference at the location of the rebuilding, repair
                          or replacement by strikers or other persons; or
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(b) </b>Suspension, lapse or cancellation of any
                          license, lease or contract. But if the suspension,
                          lapse or cancellation is directly caused by the
                          "suspension" of "operations", we will cover such loss
                          that affects your Business Income during the "period
                          of restoration" and any extension of the "period of
                          restoration" in accordance with the terms of the
                          Extended Business Income Additional Coverage and the
                          Extended Period Of Indemnity Optional Coverage or any
                          variation of these.
                        </span>
              </li>
                      </ul>
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(4) </b>Any Extra Expense caused by or resulting from
                      suspension, lapse or cancellation of any license, lease or
                      contract beyond the "period of restoration".
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(5) </b>Any other consequential loss.</span>
              </li>
                  </ul>
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 5 -->
<div class="pdf-page app-cp-10-10-10-12">
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol type="a" start="2">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Leasehold Interest Coverage Form </b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>Paragraph <b>B.1.a.,</b> Ordinance Or Law, does not
                  apply to insurance under this Coverage Form.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>We will not pay for any loss caused by:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(a) </b>Your cancelling the lease;</span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>The suspension, lapse or cancellation of any
                      license; or
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(c) </b>Any other consequential loss.</span>
              </li>
                  </ul>
                </span>
              </li>
              </ul>
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Legal Liability Coverage Form </b>
              <ul style="list-style-type: none">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(1) </b>The following exclusions do not apply to insurance
                  under this Coverage Form:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) </b>Paragraph <b>B.1.a.</b> Ordinance Or Law;
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) </b>Paragraph <b>B.1.c.</b> Governmental Action;
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;"><b>(c) </b>Paragraph <b>B.1.d.</b> Nuclear Hazard;</span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(d) </b>Paragraph <b>B.1.e.</b> Utility Services; and
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(e) </b>Paragraph <b>B.1.f.</b> War And Military
                      Action.
                    </span>
              </li>
                  </ul>
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>(2) </b>The following additional exclusions apply to
                  insurance under this Coverage Form:
                  <ul style="list-style-type: none">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(a) Contractual Liability</b><br />
                      We will not defend any claim or "suit", or pay damages
                      that you are legally liable to pay, solely by reason of
                      your assumption of liability in a contract or agreement.
                      But this exclusion does not apply to a written lease
                      agreement in which you have assumed liability for building
                      damage resulting from an actual or attempted burglary or
                      robbery, provided that:
                      <ul style="list-style-type: none">
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(i) </b>Your assumption of liability was executed
                          prior to the accident; and
                        </span>
              </li>
                        <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                          <b>(ii) </b>The building is Covered Property under
                          this Coverage Form.
                        </span>
              </li>
                      </ul>
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      <b>(b) Nuclear Hazard </b>
                      <br />
                      We will not defend any claim or "suit", or pay any
                      damages, loss, expense or obligation, resulting from
                      nuclear reaction or radiation, or radioactive
                      contamination, however caused.
                    </span>
              </li>
                  </ul>
                </span>
              </li>
              </ul>
            </span>
              </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ol type="A" start="3">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b
                >Additional Coverage - Limited Coverage For "Fungus", Wet Rot,
                Dry Rot And Bacteria</b
              >
              <ol>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The coverage described in <b>C.2.</b> and <b>C.6.</b> only
                  applies when the "fungus", wet or dry rot or bacteria are the
                  result of one or more of the following causes that occur
                  during the policy period and only if all reasonable means were
                  used to save and preserve the property from further damage at
                  the time of and after that occurrence:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      A Covered Cause of Loss other than fire or lightning; or
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      Flood, if the Flood Coverage Endorsement applies to the
                      affected premises.
                    </span>
              </li>
                  </ol>
                  This Additional Coverage does not apply to lawns, trees,
                  shrubs or plants which are part of a vegetated roof.
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  We will pay for loss or damage by "fungus", wet or dry rot or
                  bacteria. As used in this Limited Coverage, the term loss or
                  damage means:
                  <ol type="a">
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      Direct physical loss or damage to Covered Property caused
                      by "fungus", wet or dry rot or bacteria, including the
                      cost of removal of the "fungus", wet or dry rot or
                      bacteria;
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      The cost to tear out and replace any part of the building
                      or other property as needed to gain access to the
                      "fungus", wet or dry rot or bacteria; and
                    </span>
              </li>
                    <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                      The cost of testing performed after removal, repair,
                      replacement or restoration of the damaged property is
                      completed, provided there is a reason to believe that
                      "fungus", wet or dry rot or bacteria are present.
                    </span>
              </li>
                  </ol>
                </span>
              </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  The coverage described under <b>C.2.</b> of this Limited
                  Coverage is limited to $15,000. Regardless of the number of
                  claims, this limit is the most we will pay for the total of
                  all loss or damage arising out of all occurrences of Covered
                  Causes of Loss (other than fire or lightning) and Flood which
                  take place in a 12- month period (starting with the beginning
                  of the present annual policy period). With respect to a
                  particular occurrence of loss which results in "fungus", wet
                  or dry rot or bacteria, we will not pay more than a total of
                  $15,000 even if the "fungus", wet or dry rot or bacteria
                  continue to be present or active, or recur, in a later policy
                  period.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 6 -->
<div class="pdf-page app-cp-10-10-10-12">
  <table class="font-small" style="width: 100%">
    <tbody>
      <tr>
        <!-- Left -->
        <td style="width: 50%; vertical-align: top">
          <ol start="4">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The coverage provided under this Limited Coverage does not
              increase the applicable Limit of Insurance on any Covered
              Property. If a particular occurrence results in loss or damage by
              "fungus", wet or dry rot or bacteria, and other loss or damage, we
              will not pay more, for the total of all loss or damage, than the
              applicable Limit of Insurance on the affected Covered Property.<br />
              If there is covered loss or damage to Covered Property, not caused
              by "fungus", wet or dry rot or bacteria, loss payment will not be
              limited by the terms of this Limited Coverage, except to the
              extent that "fungus", wet or dry rot or bacteria cause an increase
              in the loss. Any such increase in the loss will be subject to the
              terms of this Limited Coverage
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The terms of this Limited Coverage do not increase or reduce the
              coverage provided under Paragraph <b>b.</b> of Covered Causes Of
              Loss <b>9.</b> Sprinkler Leakage.
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              The following, <b>6.a.</b> or <b>6.b.,</b> applies only if
              Business Income and/or Extra Expense Coverage applies to the
              described premises and only if the "suspension" of "operations"
              satisfies all terms and conditions of the applicable Business
              Income and/or Extra Expense Coverage Form:
              <ol type="a">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  If the loss which resulted in "fungus", wet or dry rot or
                  bacteria does not in itself necessitate a "suspension" of
                  "operations", but such "suspension" is necessary due to loss
                  or damage to property caused by "fungus", wet or dry rot or
                  bacteria, then our payment under Business Income and/or Extra
                  Expense is limited to the amount of loss and/or expense
                  sustained in a period of not more than 30 days. The days need
                  not be consecutive.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ol>
        </td>
        <!-- Right -->
        <td style="width: 50%; vertical-align: top">
          <ul style="list-style-type: none">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <ol type="a" start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  If a covered "suspension" of "operations" was caused by loss
                  or damage other than "fungus", wet or dry rot or bacteria but
                  remediation of "fungus", wet or dry rot or bacteria prolongs
                  the "period of restoration", we will pay for loss and/or
                  expense sustained during the delay (regardless of when such a
                  delay occurs during the "period of restoration"), but such
                  coverage is limited to 30 days. The days need not be
                  consecutive.
                </span>
              </li>
              </ol>
            </span>
              </li>
          </ul>
          <ol type="A" start="4">
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Limitation</b><br />
              We will pay for loss of animals only if they are killed or their
              destruction is made necessary.
            </span>
              </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              <b>Definitions</b><br />
              "Fungus" means any type or form of fungus, including mold or
              mildew, and any mycotoxins, spores, scents or by-products produced
              or released by fungi.
            </span>
              </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
